import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/common/hooks';
import { selectModalSource, selectModalStatus } from 'shared/common/selectors/modalStatus';
import { setModalStatus } from 'shared/common/slices';
import { EModalSource, EModalStatus } from 'shared/common/types/modal';
import { QualityCriteriaModal } from '../../components/QualityCriteriaModal';

export const QualityCriteriaModalContainer: FC = () => {
  const dispatch = useAppDispatch();
  const modalStatus = useSelector(selectModalStatus);
  const modalSource = useSelector(selectModalSource);

  const handleModalClose = useCallback(() => {
    dispatch(setModalStatus(EModalStatus.Hide));
  }, [dispatch]);

  const isOpen = modalStatus === EModalStatus.Open && modalSource === EModalSource.QualityCriteria;

  return <QualityCriteriaModal isOpen={isOpen} handleClose={handleModalClose} />;
};
